import * as React from 'react';
import styled from 'styled-components';
import { GridButton } from '../appComponents/Styles';

const AddNewGridButton = (props: Props) => {
	const { onClick, name, fullName } = props;
	const tooltipTitle = fullName || `Add new${name ? ` ${name}` : ''}`;
	return (
		<OutlineButton
			title={tooltipTitle}
			onClick={(e: React.MouseEvent<HTMLElement>) => {
				onClick();
				e.preventDefault();
			}}
			fillMode="outline"
		>
			+ {tooltipTitle}
		</OutlineButton>
	);
};

export default AddNewGridButton;

interface Props {
	onClick: () => void;
	name?: string;
	fullName?: string;
}

const OutlineButton = styled(GridButton)`
	&:hover {
		background-color: ${(props) => props.theme.brandingColourHeavy};
		color: white;
	}
`;
